/** Invisible loading screen — intentionally blank to seamlessly bridge splash → app */
const SimpleLoading = () => {
  return (
    <div className="min-h-screen bg-background" />
  );
};

export default SimpleLoading;
